export const REVIEWS_PENDING = "REVIEWS_PENDING";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_RECENT_REVIEWS = "GET_RECENT_REVIEWS";
export const REVIEWS_REJECTED = "REVIEWS_REJECTED";
export const POST_REVIEWS = "POST_REVIEWS";